module.exports = __webpack_public_path__ + "img/ft-preview.2cc90cad.svg";